module.exports = __webpack_public_path__ + "static/media/6.f08c7864.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/6.svg
// module id = 2838
// module chunks = 3